import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../../common.service';
@Component({
  selector: 'app-view-animal-deworming',
  templateUrl: './view-animal-deworming.component.html',
  styleUrls: ['./view-animal-deworming.component.css']
})
export class ViewAnimalDewormingComponent implements OnInit {
  getanimaldewormingviewApi:any;
  testdate:any;
  testdate1:any;
  returnUrl="/dashboard/RottweilerDogsAnimalmanagement"
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit(){
    let dewormingId = sessionStorage.getItem('dewormingId');
    this.getanimaldewormingviewApi= "/animal_management/deworming/"+dewormingId;
    (await this.commonService.getApi(this.getanimaldewormingviewApi)).subscribe(
      res => { 
        console.log(res.data);
        var date=res.data.tnam_dew_deworming_date;
         this.testdate = date.split('T');
         var date=res.data.tnam_dew_expiry_date;
         this.testdate1 = date.split('T');
       // $("#ExpiryDate").text(testdate[0])
       $("#dewormingname").text(res.data.tnam_dew_deworming_name),
       $("#batchno").text(res.data.tnam_dew_batch_number),
    //   $("#DiscoveryDate").text(res.data.tnam_dis_date_of_discovery)
       $("#Description").text(res.data.tnam_dew_deworming_description)
      })
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }
}
